import { ApiErrorCatalog, ResolveApiErrorProps } from '../core/api-error';
import { Failure } from '../core/failure';

export enum PhoneNumbersRepositoryFailureTypes {
  failToComunicateWithTheServer,
}

export class PhoneNumbersRepositoryFailure extends Failure<
  PhoneNumbersRepositoryFailureTypes,
  void
> {
  private constructor(errorMessage: string, errorType: PhoneNumbersRepositoryFailureTypes) {
    super(errorMessage, errorType, undefined);
  }

  public static fromApiError(props: ResolveApiErrorProps) {
    return new PhoneNumbersRepositoryFailure(
      ApiErrorCatalog.resolveMessage(props),
      PhoneNumbersRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }

  public static failToComunicateWithTheServer() {
    return new PhoneNumbersRepositoryFailure(
      'Falha ao carregar os números corporativos',
      PhoneNumbersRepositoryFailureTypes.failToComunicateWithTheServer
    );
  }
}
